import { ChevronLeft, X } from "lucide-react";

import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { useVidyoStore } from "@/features/vidyo-call/utils/vidyo-store";

import { ExtendByCustomAmountForm } from "./extend-by-custom-amount-form";
import { QuickExtend } from "./quick-extend";
import { RoomSystemConflicts } from "./room-system-conflicts";

export function ExtendSessionDrawer() {
  const setActiveTab = useVidyoStore((s) => s.moderationDrawer.setActiveTab);
  const closeExtendSessionDrawer = useVidyoStore(
    (s) => s.moderationDrawer.close,
  );

  return (
    <div className="flex h-full flex-col">
      <div className="flex items-center">
        <Button
          variant="ghost"
          size="icon"
          onClick={() => setActiveTab()}
          className="ml-2 mr-1"
        >
          <ChevronLeft className="size-4" />
        </Button>
        <p
          className="py-4 text-sm text-foreground"
          id="moderation-drawer-title"
        >
          Session Moderation
        </p>

        <Button
          variant="ghost"
          size="icon"
          onClick={closeExtendSessionDrawer}
          className="absolute right-2 top-2"
        >
          <X className="size-4" />
        </Button>
      </div>

      <Separator className="mb-4 bg-border" />
      <div className="flex flex-col px-4">
        <p className="mb-2 text-sm text-secondary">Quick Extend</p>
        <QuickExtend />
        <p className="mb-2 text-sm text-secondary">Extend by Custom Amount</p>
        <ExtendByCustomAmountForm />

        <RoomSystemConflicts />
      </div>
    </div>
  );
}
